<template>
  <main
    data-qa="ethical_commission_content"
    class="d-flex flex-column"
    :class="isMobile ? 'px-2 py-6 ga-6' : 'ga-4'"
  >
    <InfoCard
      data-qa="ethical_commission_content_goals_and_objectives"
      :title="t('Цели и задачи', options)"
    >
      <div class="text-body-2">
        <!-- eslint-disable max-len vue/max-len -->
        {{ t('Этический комитет — независимая комиссия для оценки отзывов и разрешения спорных ситуаций между медицинскими специалистами и пациентами. Способствует публикации достоверных и обоснованных отзывов на портале. Контролирует соблюдение прав медработников и пациентов при публичном выражении мнения.', options) }}
        <!-- eslint-enable max-len vue/max-len -->
      </div>
    </InfoCard>
    <InfoCard
      data-qa="ethical_commission_content_meetings_results"
      :title="t('Результаты заседаний', options)"
    >
      <div class="text-body-2 text--text">
        <!-- eslint-disable max-len vue/max-len -->
        {{ t('Два раза в месяц члены этического комитета рассматривают обращения на заочном и очном заседаниях. За месяц принимается решение по 8 - 10 заявкам.', options) }}
        <!-- eslint-enable max-len vue/max-len -->
      </div>
      <div
        class="d-flex gc-5 gr-4"
        :class="isMobile ? 'flex-column' : 'justify-space-between'"
      >
        <div class="bg-secondary rounded py-3 px-5 d-flex align-center w-100">
          <div class="ui-icon-shield icon-secondary--text" />
          <div class="text-body-1 text--text ml-4">
            {{ ethicalCommissionMeetingsCount }} {{ getMeetingsCountCaseText() }} {{ t('было проведено', options) }}
          </div>
        </div>
        <div class="bg-secondary rounded py-3 px-5 d-flex align-center w-100">
          <div class="ui-icon-hand-shaking icon-secondary--text" />
          <div class="text-body-1 text--text ml-4">
            {{ t('Дали независимую оценку', options) }} {{ ethicalCommissionCasesCount }} {{ getCasesCountCaseText() }}
          </div>
        </div>
      </div>
      <v-btn
        :href="reverseFull({ name: 'info_ethical_commission_meetings' })"
        :class="{ 'align-self-start': !isMobile }"
        color="primary"
        depressed
      >
        {{ t('Перейти к результатам', options) }}
        <span class="ui-icon-arrow-next bg-gray-0--text ml-2" />
      </v-btn>
    </InfoCard>
    <InfoCard
      v-if="context.feature_flags.update_ethical_commission_page"
      data-qa="ethical_commission_content_structure"
      :title="t('Структура этического комитета', options)"
    >
      <div class="d-flex flex-column ga-4 text-body-2 text--text">
        <div>
          {{ t('Структура Этического комитета включает Этическую коллегию и Этический консилиум.', options) }}
        </div>
        <div>
          <!-- eslint-disable max-len vue/max-len -->
          {{ t('Этическая коллегия состоит из', options) }}
          <template v-if="gradeCount.reviewers > 0">
            {{ gradeCount.reviewers }}
          </template>
          {{ getReviewersLabel() }}, {{ t('оперативно принимающих решения и формирующих первичное заключение. Участвуют только в заочных заседаниях. На данном уровне принимается решение по подавляющему большинству обращений. Заседания проводятся раз в месяц.', options) }}
          <!-- eslint-enable max-len vue/max-len -->
        </div>
        <div>
          <!-- eslint-disable max-len vue/max-len -->
          {{ t('Этический консилиум включает', options) }}
          <template v-if="gradeCount.experts > 0">
            {{ gradeCount.experts }}
          </template> {{ getExpertsLabel() }}. {{ t('Собирается только по сложным, прецедентным или конфликтным случаям, требующим глубокой аргументации. Также участвуют в работе «Этической коллегии». Очные заседания проводятся по необходимости. В случае привлечения экспертов, указывается, что «Решение принято коллегией советников Этического консилиума по итогам очной полемической дискуссии и устных обоснований экспертов».', options) }}
          <!-- eslint-enable max-len vue/max-len -->
        </div>
      </div>
    </InfoCard>
    <InfoCard
      data-qa="ethical_commission_content_initiate_check"
      :title="t('Как инициировать проверку', options)"
    >
      <div class="text-body-2 text--text">
        <!-- eslint-disable max-len vue/max-len -->
        {{ t('Запросить проверку принятого порталом решения о публикации или непубликации отзыва может пациент, врач или клиника.', options) }}<br>
        <!-- eslint-enable max-len vue/max-len -->
        {{ t('Обращения можно направлять на', options) }} <a
          href="mailto:ethics@medrocket.ru"
          class="primary--text link-decoration-none"
        >ethics@medrocket.ru</a> {{ t('с указанием ссылки на спорный отзыв.', options) }} <br>
        {{ t('До отправки обращения по спорному отзыву убедитесь:', options) }} <br>
        <!-- eslint-disable max-len vue/max-len -->
        • {{ t('что отзыв прошёл расширенную проверку или собран колл-центром', options) }} <br>
        • {{ t('в письме указана ссылка на отзыв и дата публикации', options) }} <br>
        • {{ t('вы написали своими словами, почему решение о публикации / непубликации отзыва является неэтичным (не соответствующим нормам этики и морали).', options) }}
        <!-- eslint-enable max-len vue/max-len -->
      </div>
    </InfoCard>
    <InfoCard
      data-qa="ethical_commission_content_members"
      :title="t('Члены этического комитета', options)"
    >
      <template v-for="(ethicalCommission, index) in ethicalCommissions">
        <div
          :key="`member-group-${index}`"
          data-qa="ethical_commission_content_member_group"
          class="member-group__title text-subtitle-1"
        >
          {{ ethicalCommission.member_group_name }}
        </div>

        <MemberCard
          v-for="(member, indexMember) in ethicalCommission.members"
          :key="`member-${member.last_name}-${member.first_name}-${member.second_name}-${indexMember}`"
          :member="member"
        />
      </template>
    </InfoCard>
  </main>
</template>

<script lang="ts" setup>
import { type ContextStore, EthicalCommission } from 'src/components/pages/info/ethical-commission/index/types'
import MemberCard from 'src/components/pages/info/ethical-commission/index/components/MainContent/components/MemberCard.vue'
import InfoCard from 'src/components/pages/info/ethical-commission/index/components/MainContent/components/InfoCard.vue'
import declensionByNum from 'www/utils/executors/declensionByNum'
import { useContextStore, useURLStore } from 'src/store'
import { computed } from 'vue'
import I18NextVue from 'i18next'

const { t, language } = I18NextVue
const options = { ns: language }

const props = defineProps<{
  ethicalCommissionMeetingsCount: number
  ethicalCommissionCasesCount: number
  ethicalCommissions: EthicalCommission[]
}>()

const { reverseFull } = useURLStore()

const { context }: ContextStore = useContextStore()
const isMobile = computed(() => context.flavour === 'mobile')
const gradeCount = computed(() => {
  let experts = 0
  let reviewers = 0

  props.ethicalCommissions.forEach(group => {
    group.members.forEach(member => {
      if (member.ethical_commission_member_grade === 'expert') {
        experts += 1
      } else if (member.ethical_commission_member_grade === 'reviewer') {
        reviewers += 1
      }
    })
  })

  return {
    experts,
    reviewers,
  }
})

function getMeetingsCountCaseText() {
  return declensionByNum(props.ethicalCommissionMeetingsCount, ['заседание', 'заседания', 'заседаний'])
}

function getCasesCountCaseText() {
  return declensionByNum(props.ethicalCommissionCasesCount, ['отзыву', 'отзывам', 'отзывам'])
}

function getReviewersLabel() {
  return declensionByNum(gradeCount.value.reviewers, ['рецензента', 'рецензентов', 'рецензентов'])
}

function getExpertsLabel() {
  const count = gradeCount.value.experts
  const advisors = declensionByNum(count, ['советника', 'советников', 'советников'])
  const experts = declensionByNum(count, ['эксперта', 'экспертов', 'экспертов'])

  return t(`${advisors} (${experts})`, options)
}
</script>
